import { connect } from 'react-redux';
import MiniPlayer from './mini-player.component';

const mapStateToProps = ({ player }) => ({
  isMiniPlayerOpen: Number.isInteger(player.activeIndex),
});

export default connect(mapStateToProps)(MiniPlayer);
